import { paramCase } from 'change-case';

export const EVENTS = {
	KSYS_APP_LOADED: 'ksys-app-loaded',
	KSYS_APPS_LOADED: 'ksys-apps-loaded',
	KSYS_APP_EMBED_ADDED: 'ksys-app-embed-added',
	KSYS_APP_MANAGER_INITIALIZED: 'ksys-app-manager-initialized',
	KSYS_APP_PREVIEW_UPDATED: 'ksys-app-preview-updated',
};
export async function triggerEvent(name: string, dispatcher: HTMLElement | Document = document) {
	const debug = await import('./isDebug.js');
	const { isDebug } = debug;
	if (isDebug()) {
		console.info(`event triggered: ${name}`);
	}

	const event = new CustomEvent(name, {
		bubbles: true,
		cancelable: true,
	});

	dispatcher.dispatchEvent(event);
}

(window as any).ksysTriggerEvent = triggerEvent;
if (window.parent) {
	try {
		(window.parent as any).ksysTriggerEvent = triggerEvent;
		(window.parent as any).childDocument = document;
		(window.parent as any).childWindow = window;
	} catch (e) {
		console.warn('Unable to access parent window:', e);
	}
}

export function generateElementSelector(dispatcher: HTMLElement | Document) {
	if (dispatcher instanceof Document) {
		return 'document';
	}

	if (dispatcher.dataset) {
		const datasetKeys = Object.keys(dispatcher.dataset).sort();
		return datasetKeys
			.reduce((key: string[], datasetKey: string) => {
				const value = dispatcher.dataset[datasetKey];
				key.push(`[data-${paramCase(datasetKey)}="${value}"]`);
				return key;
			}, [])
			.join('');
	}

	let str = dispatcher.tagName;
	str += dispatcher.id != '' ? '#' + dispatcher.id : '';
	if (dispatcher.className) {
		const classes = dispatcher.className.split(/\s/);
		for (let i = 0; i < classes.length; i++) {
			str += '.' + classes[i];
		}
	}
	return str;
}

function appendEventDetail(name: string, elementSelector: string) {
	const existingEventDetailString = sessionStorage.getItem('ksys-app-events') || '{}';
	try {
		let existingEventDetails = JSON.parse(existingEventDetailString);
		if (typeof existingEventDetails !== 'object') {
			existingEventDetails = {};
		}
		if (existingEventDetails.events === undefined) {
			existingEventDetails.events = {};
		}
		if (existingEventDetails.events[name] === undefined) {
			existingEventDetails.events[name] = [];
		}
		existingEventDetails.events[name].push(elementSelector);
		return existingEventDetails;
	} catch (e) {
		console.log(e.message);
	}
}

export function hasEventDetail(name: string, elementSelector: string, remove = false) {
	const existingEventDetailString = sessionStorage.getItem('ksys-app-events');
	if (typeof existingEventDetailString !== 'string') {
		return false;
	}

	try {
		const existingEventDetails = JSON.parse(existingEventDetailString);
		if (typeof existingEventDetails !== 'object') {
			return false;
		}
		if (existingEventDetails.events === undefined) {
			return false;
		}
		if (existingEventDetails.events[name] === undefined) {
			return false;
		}
		const hasSelector = existingEventDetails.event[name].includes(elementSelector);
		if (remove && hasSelector) {
			existingEventDetails.event[name] = existingEventDetails.event[name].slice(
				existingEventDetails.event[name].indexOf(elementSelector),
			);
			setAppEventDetail(existingEventDetails);
		}
		return hasSelector;
	} catch (e) {
		return false;
	}
}

function setAppEventDetail(eventDetails: object) {
	sessionStorage.setItem('ksys-app-events', JSON.stringify(eventDetails));
}
